import { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function UserMenu() {
    const { user, logout } = useAuth();
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="relative" ref={containerRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center gap-3 p-1 rounded-full hover:bg-white/5 transition-colors"
            >
                <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center text-black font-medium text-sm shadow-lg ring-2 ring-transparent">
                    {user?.name?.[0] || 'U'}
                </div>
                <i className={`ri-arrow-down-s-line text-zinc-400 transition-transform ${isOpen ? 'rotate-180' : ''}`}></i>
            </button>

            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, y: 10, scale: 0.95 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 10, scale: 0.95 }}
                        transition={{ duration: 0.2 }}
                        className="absolute right-0 top-full mt-2 w-56 rounded-xl bg-[#0a0a0a] border border-white/[0.08] shadow-2xl overflow-hidden z-50 backdrop-blur-xl"
                    >
                        <div className="p-4 border-b border-white/[0.08] bg-white/[0.02]">
                            <p className="text-sm font-medium text-white truncate">{user?.name}</p>
                            <p className="text-xs text-zinc-500 truncate">{user?.email}</p>
                        </div>
                        <div className="p-1">
                            <button
                                onClick={() => { setIsOpen(false); navigate('/dashboard/profile'); }}
                                className="w-full flex items-center gap-3 px-3 py-2 text-sm text-zinc-300 hover:text-white hover:bg-white/[0.05] rounded-lg transition-colors"
                            >
                                <i className="ri-user-settings-line"></i>
                                Profile Settings
                            </button>
                            <button
                                onClick={() => { setIsOpen(false); navigate('/dashboard/credits'); }}
                                className="w-full flex items-center gap-3 px-3 py-2 text-sm text-zinc-300 hover:text-white hover:bg-white/[0.05] rounded-lg transition-colors"
                            >
                                <i className="ri-coin-line"></i>
                                Credits
                            </button>
                            <div className="my-1 mx-3 border-t border-white/[0.06]" />
                            <button
                                onClick={handleLogout}
                                className="w-full flex items-center gap-3 px-3 py-2 text-sm text-red-400 hover:text-red-300 hover:bg-red-500/10 rounded-lg transition-colors"
                            >
                                <i className="ri-logout-box-line"></i>
                                Sign Out
                            </button>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}
